// Part F motion: mirror each question's text into data-q, the text source
// for the open-state gradient title layer.
export const initFaqLit = () => {
    const questions = document.querySelectorAll("#faq .faq-mnt-q");
    if (questions.length === 0) {
        return;
    }
    questions.forEach(question => {
        if (question.hasAttribute("data-q")) {
            return;
        }
        question.setAttribute("data-q", question.textContent);
    });
};
